import { z } from "zod";
import { zInvoiceStatus, zLedgerEntryClass, zLedgerEntryType, zPaymentState } from "./settlements.common";
export const zCorpInvoiceDom = z.object({
    invoiceId: z.string(),
    companyId: z.string(),
    number: z.string(),
    periodStart: z.string(),
    periodEnd: z.string(),
    issueDate: z.string(),
    dueDate: z.string(),
    total: z.number(),
    ordersCount: z.number(),
    totalKwh: z.number(),
    status: zInvoiceStatus,
    externalDocNumber: z.string().nullable(),
    externalDocDate: z.string().nullable(),
    paidAmount: z.number().nullable(),
    paymentState: zPaymentState.nullable(),
    isOverdue: z.boolean(),
    daysOverdue: z.number().nullable(),
    runId: z.string().nullable(),
    voidedAt: z.string().nullable(),
    voidedBy: z.string().nullable(),
    voidReason: z.string().nullable(),
});
export const zCorpInvoiceLineDom = z.object({
    lineId: z.string(),
    invoiceId: z.string(),
    companyId: z.string(),
    orderId: z.string().nullable(),
    orderNumber: z.string().nullable(),
    lineDate: z.string(),
    description: z.string().nullable(),
    employeeLabel: z.string().nullable(),
    kwh: z.number().nullable(),
    pricePerKwh: z.number().nullable(),
    serviceFee: z.number().nullable(),
    amount: z.number(),
});
export const zCorpPaymentDom = z.object({
    paymentId: z.string(),
    companyId: z.string(),
    amount: z.number(),
    paidAt: z.string(),
    docNumber: z.string().nullable(),
    docDate: z.string().nullable(),
    comment: z.string().nullable(),
    isVoided: z.boolean(),
    voidedAt: z.string().nullable(),
    createdAt: z.string(),
    createdBy: z.string().nullable(),
    voidedBy: z.string().nullable(),
    voidReason: z.string().nullable(),
});
/** `reversesEntryId`/`createdByKind` — до WP-DB-05 приходят `null` (CCR-029). */
export const zCorpLedgerEntryDom = z.object({
    entryId: z.string(),
    companyId: z.string(),
    entryType: zLedgerEntryType,
    entryClass: zLedgerEntryClass,
    amount: z.number(),
    effectiveAt: z.string(),
    description: z.string().nullable(),
    orderId: z.string().nullable(),
    orderNumber: z.string().nullable(),
    paymentId: z.string().nullable(),
    invoiceId: z.string().nullable(),
    invoiceNumber: z.string().nullable(),
    createdAt: z.string(),
    createdBy: z.string().nullable(),
    reversesEntryId: z.string().nullable(),
    createdByKind: z.string().nullable(),
});
